import React, {FC, useState} from "react";
import {ColoredText, CustomLink, Image, Money} from "../../../common";
import Username from "../../Username";
import {useNavigateByName, useProfileData} from "../../../../hooks";
import profileCross from "../../../../assets/images/svg/profile-menu-cross.svg";
import burger from "../../../../assets/images/svg/burger.svg";
import {TextColor} from "../../../common/typography/texts/ColoredText/ColoredText";
import {RouteDictionary} from "../../../../utils";
import styles from "./ProfileMenu.module.scss";

interface Props {
  clickable?: boolean;
}

const ProfileMenu: FC<Props> = ({clickable = true}) => {
  const profileData = useProfileData();
  const navigate = useNavigateByName();
  const [active, setActive] = useState(false);

  const handleClick = () => {
    setActive((prev) => !prev);
    if (!clickable) {
      navigate(RouteDictionary.PROFILE);
    }
  };

  return (
    <div className={styles.profile} onClick={handleClick}>
      <div className={styles.profile__user}>
        <div>
          <div>
            <Username />
          </div>
          <div className={styles.profile__balance}>
            <Money money={profileData.balance} />
          </div>
          {profileData.isQualified && (
            <div className={styles.profile__qualified}>квалифицированный инвестор</div>
          )}
        </div>
      </div>

      {clickable && (
        <div className={styles.profile__toggle}>
          <Image
            className={active ? styles.profile__toggle__imageCross : styles.profile__toggle__imageBurger}
            src={active ? profileCross : burger}
          />

          {active && (
            <div className={styles.actions__wrapper}>
              <div className={styles.actions}>
                <div className={styles.actions__container}>
                  <ul className={styles.actions__list}>
                    <li className={styles.actions__element}>
                      <CustomLink to={RouteDictionary.REFERRAL} className={styles.actions__link}>
                              Реферальный доход
                      </CustomLink>
                    </li>
                    <li className={styles.actions__element}>
                      <CustomLink to={RouteDictionary.DOCUMENTS_TO_PROJECT} className={styles.actions__link}>
                              Документы
                      </CustomLink>
                    </li>
                    <li className={styles.actions__element}>
                      <CustomLink to={RouteDictionary.NOTIFICATIONS} className={styles.actions__link}>
                              Уведомления
                      </CustomLink>
                    </li>
                    <li className={styles.actions__element}>
                      <CustomLink to={RouteDictionary.PROFILE} className={styles.actions__link}>
                              Профиль
                      </CustomLink>
                    </li>
                  </ul>
                </div>
                <div className={styles.actions__container}>
                  <ul className={styles.actions__list}>
                    <li className={styles.actions__element}>
                      <ColoredText color={TextColor.PRIMARY_GREEN}>
                        <CustomLink to={RouteDictionary.LOGOUT} className={styles.actions__link}>
                                Выйти
                        </CustomLink>
                      </ColoredText>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProfileMenu;